<h2 mat-dialog-title>
  {{ 'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.TITLE_V2' | translate }}
</h2>
<mat-dialog-content>
  <glxy-alert type="info">
    <strong>{{ 'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.ALERT_TITLE' | translate }}</strong>
    - {{ 'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.ALERT_BODY' | translate }}
  </glxy-alert>
  <div class="dialog-content">
    <ng-container *ngIf="!isAutomationDraining()">
      <form [formGroup]="form" novalidate>
        <glxy-form-field [showInputDecoration]="true">
          <glxy-label>{{ 'AUTOMATIONS.SETTINGS.RUN_OPTIONS.TITLE' | translate }}</glxy-label>
          <glxy-label-hint>
            {{
              'AUTOMATIONS.SETTINGS.RUN_OPTIONS.RUN_INSTRUCTIONS_V2'
                | translate
                  : {
                      an_entity: automation.entityType | entity: true | async,
                      entity: automation.entityType | entity: false : true | async | lowercase
                    }
            }}
          </glxy-label-hint>
          <mat-radio-group class="radio-group" formControlName="runType" aria-labelledby="run-options">
            <div class="radio-option" *ngFor="let runTypeOption of runTypeOptions">
              <mat-radio-button [value]="runTypeOption.value" tabindex="-1">
                {{
                  runTypeOption.label
                    | translate: { entity: automation.entityType | entity: false : true | async | lowercase }
                }}
                <extended class="hint" *ngIf="!!runTypeOption.hint">
                  {{ runTypeOption.hint | translate }}
                </extended>
              </mat-radio-button>
            </div>
          </mat-radio-group>
        </glxy-form-field>
        <glxy-form-field [showInputDecoration]="true">
          <glxy-label>{{ 'AUTOMATIONS.SETTINGS.ERROR_HANDLING_OPTIONS.TITLE' | translate }}</glxy-label>
          <glxy-label-hint>
            {{ 'AUTOMATIONS.SETTINGS.ERROR_HANDLING_OPTIONS.ERROR_HANDLING_INSTRUCTIONS_SHORT' | translate }}
          </glxy-label-hint>
          <mat-radio-group
            class="radio-group"
            formControlName="errorHandlingType"
            aria-labelledby="error-handling-options"
          >
            <div class="radio-option" *ngFor="let errorHandlingTypeOption of errorHandlingTypeOptions">
              <mat-radio-button class="radio-button" [value]="errorHandlingTypeOption.value" tabindex="-1">
                {{ errorHandlingTypeOption.label | translate }}
                <extended class="hint" *ngIf="!!errorHandlingTypeOption.hint">
                  {{ errorHandlingTypeOption.hint | translate }}
                </extended>
              </mat-radio-button>
            </div>
          </mat-radio-group>
        </glxy-form-field>
      </form>
      <ng-container *ngIf="originBuiltInAutomationOn$ | async">
        <ng-container *ngIf="originBuiltInAutomation$ | async as originBuiltInAutomation">
          <h3>
            {{ 'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.BUILT_IN_ORIGIN.SUBTITLE' | translate }}
          </h3>
          <p
            [innerHTML]="
              'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.BUILT_IN_ORIGIN.TURNED_ON_BANNER'
                | translate: { built_in_automation_name: originBuiltInAutomation.name }
                | iTrustThisHtml
            "
          ></p>
          <glxy-alert
            type="warning"
            [showClose]="false"
            [showAction]="true"
            [actionTitle]="'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.BUILT_IN_ORIGIN.REVIEW' | translate"
            [actionExternalLink]="'/automations/automation/' + originBuiltInAutomation.id + '/workflow'"
          >
            <span>
              {{ 'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.BUILT_IN_ORIGIN.WARNING_MESSAGE' | translate }}
            </span>
          </glxy-alert>
        </ng-container>
      </ng-container>
      <div class="subscription">
        <mat-checkbox [formControl]="subscriptionFormControl">
          {{ 'AUTOMATIONS.SETTINGS.SUBSCRIBE_TO_ERRORS' | translate }}
        </mat-checkbox>
      </div>
    </ng-container>
    <ng-container *ngIf="isAutomationDraining()">
      <p>{{ 'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.TURN_ON_FROM_DRAINING.DESCRIPTION' | translate }}</p>
      <glxy-alert type="info">
        <span [innerHTML]="'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.TURN_ON_FROM_DRAINING.ALERT' | translate"></span>
      </glxy-alert>
    </ng-container>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="button-container">
    <div>
      <button mat-button color="primary" mat-dialog-close>
        {{ 'AUTOMATIONS.COMMON.CANCEL' | translate }}
      </button>
      <button mat-raised-button mat-button color="primary" (click)="continue()">
        {{ 'AUTOMATIONS.TURN_ON_AUTOMATION_DIALOG.TURN_ON' | translate }}
      </button>
    </div>
    <div *ngIf="!isAutomationDraining()">
      <button mat-button color="primary" (click)="goToSettings()" tabindex="-1">
        {{ 'AUTOMATIONS.COMMON.GO_TO_SETTINGS' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-actions>
